var map = {
	"./angry.png": "f0b9",
	"./average.png": "7341",
	"./bored.png": "b60c",
	"./excited.png": "cea7",
	"./happy.png": "f0a4",
	"./loved.png": "4fd2",
	"./okay.png": "76d8",
	"./sad.png": "6825",
	"./unhappy.png": "bbb7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "147c";